import { FC, useContext, useEffect } from "react";
import { FormsFeatureContext } from '@ngt/forms';

interface IPageTitleProps {
    title?: string;
}

export const TITLE_SEPARATOR = ' | '
export const TITLE_BASE = 'Participant Data';

const PageTitle: FC<IPageTitleProps> = ({ title }) => {
    const { organisationName } = useContext(FormsFeatureContext);

    useEffect(() => {
        const newTitle = !!title ? 
            `${title}${TITLE_SEPARATOR}${organisationName}` : //`${title}${TITLE_SEPARATOR}${TITLE_BASE}${TITLE_SEPARATOR}${organisationName}` :
            `${TITLE_BASE}${TITLE_SEPARATOR}${organisationName}`
            
        document.title = newTitle;
    }, [title, organisationName])


    return null;
}

export default PageTitle;